<template>
  <div class="services">
    <div class="ct ser_item">
      <div class="item" v-for="(item, index) in services" :key="index">
        <div class="mask"></div>
        <div class="item_title">
          <div class="content">
            {{ item.title }}
          </div>
          <div class="triangle-down"></div>
        </div>
        <div class="item_con">
          <p>
            {{ item.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      services: [
        {
          title: "7*24小时专业客服",
          content:
            "提供了7*24小时专业客服值守的不间断专业电话售前、售后支持服务"
        },
        {
          title: "严谨商务沟通",
          content:
            "经专业接口商务沟通确认数据，快捷结算严惩虚假刷量数据，保护合法权益"
        },
        {
          title: "确保公平公正",
          content: "以数据和技术来维护合法权益严惩虚假刷量和作弊手段"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.services {
  padding-top: 50px;
  padding-bottom: 68px;
  background-color: #f5f8f8;

  .ser_item {
    display: flex;
    justify-content: space-between;

    .item {
      position: relative;
      width: 340px;
      height: 220px;
      background-color: #fff;

      .item_title {
        position: absolute;
        top: -6px;
        left: 74px;

        .content {
          width: 190px;
          text-align: center;
          line-height: 50px;
          color: #fff;
          background-color: #46a0f4;
        }
      }

      .item_con {
        padding: 0 45px;
        padding-top: 96px;
        font-size: 16px;
        text-align: justify;
        text-indent: 2em;

        p {
          line-height: 25px;
          color: #6e6e6e;
        }
      }
    }
  }
}

.mask {
  //   left: 50%;
  position: absolute;
  top: -6px;
  left: 67px;
  width: 192px;
  height: 0;
  border-width: 0 6px 6px 6px;
  border-style: none solid solid;
  border-color: transparent transparent #00377c;
}

.triangle-down {
  position: absolute;
  left: 80px;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #46a0f4;
}
</style>
